import React from 'react';
import { StringConstantsMixin } from '../mixins/shared/string_constants_mixin';
import { getFormattedTrailUrls } from '../../../../utils/trail_helpers';

const createReactClass = require('create-react-class');

const EditTrailEndBox = createReactClass({
  render() {
    const { trail, context } = this.props;
    const contributeStrings = StringConstantsMixin.strings.CONTRIBUTE;
    let actionButton = null;
    if (trail.slug) {
      const { localizedUrl } = getFormattedTrailUrls(trail, context.languageRegionCode);
      actionButton = (
        <a href={localizedUrl} className="btn simple">
          {contributeStrings.RETURN_TO_TRAIL}
        </a>
      );
    }
    return (
      <div id="contribute-start">
        <div id="contribute-title">
          <span className="contribute-title-text">
            <h1>{contributeStrings.THANKS_FOR_CONTRIBUTING}</h1>
          </span>
        </div>
        <div id="contribute-welcome">
          <div className="contribute-text">{contributeStrings.YOUR_CHANGES}</div>
        </div>
        <div id="contribute-action-bar">
          <a
            href={`${window.base_support_url}/articles/360018930672-How-do-I-update-or-change-information-about-a-trail-`}
            target="_blank"
            className="editor-help"
          >
            {contributeStrings.CONTRIBUTE_HELP}
          </a>
          <span className="buttons">{actionButton}</span>
        </div>
      </div>
    );
  }
});

export { EditTrailEndBox };
